import { SvgIcon } from '@mui/material';
import React from 'react';

export const FelixSVG = () => {
  return (
    <svg
      width="290"
      height="390"
      viewBox="0 0 290 390"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2634_2987)">
        <path
          d="M230.123 87.643C232.069 127.437 186.353 141.552 129.245 144.324C72.1369 147.096 25.2531 137.468 23.3071 97.6885C21.3611 57.9089 65.0864 3.00152 122.194 0.229325C179.302 -2.54287 228.177 47.8485 230.123 87.6281V87.643Z"
          fill="url(#paint0_linear_2634_2987)"
        />
        <path
          d="M206.052 80.2653C208.926 110.789 174.257 123.205 130.442 127.288C86.6273 131.372 50.2519 125.574 47.3778 95.0504C44.5037 64.5264 76.2386 20.8271 120.054 16.7433C163.869 12.6595 203.178 49.7414 206.052 80.2653Z"
          fill="url(#paint1_linear_2634_2987)"
        />
        <path
          d="M89.2169 79.0134C92.8628 79.0134 95.8184 76.0707 95.8184 72.4406C95.8184 68.8106 92.8628 65.8678 89.2169 65.8678C85.5711 65.8678 82.6155 68.8106 82.6155 72.4406C82.6155 76.0707 85.5711 79.0134 89.2169 79.0134Z"
          fill="white"
        />
        <path
          d="M160.336 72.4406C163.982 72.4406 166.938 69.4979 166.938 65.8678C166.938 62.2378 163.982 59.295 160.336 59.295C156.69 59.295 153.735 62.2378 153.735 65.8678C153.735 69.4979 156.69 72.4406 160.336 72.4406Z"
          fill="white"
        />
        <path
          d="M105.025 83.8722C106.881 85.5117 126.071 102.026 141.804 90.8623C144.214 89.1483 147.283 86.2718 150.157 81.2341"
          stroke="white"
          strokeMiterlimit="10"
        />
        <path
          d="M24.5796 232.885C29.5793 168.603 74.4722 152.775 128.017 156.903C181.562 161.032 223.476 183.552 218.477 247.834C213.477 312.116 163.465 393.792 109.919 389.663C56.3743 385.535 19.5798 297.153 24.5796 232.885Z"
          fill="url(#paint2_linear_2634_2987)"
        />
        <path
          d="M239.539 204.418C209.615 233.869 190.933 232.826 178.898 220.694C166.863 208.576 166.039 189.961 195.978 160.51C225.902 131.059 275.255 101.936 287.276 114.068C299.311 126.185 269.462 174.967 239.539 204.418Z"
          fill="url(#paint3_linear_2634_2987)"
        />
        <path
          d="M19.3253 220.366C36.4801 182.121 54.2636 176.338 69.8916 183.284C85.5195 190.229 93.064 207.28 75.9092 245.524C58.7544 283.768 23.4119 328.75 7.76903 321.804C-7.87387 314.859 2.17052 258.625 19.3253 220.366Z"
          fill="url(#paint4_linear_2634_2987)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2634_2987"
          x1="22.3116"
          y1="77.298"
          x2="229.117"
          y2="67.1758"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#92ADF4" />
          <stop offset="0.35" stopColor="#8EA8F3" />
          <stop offset="0.72" stopColor="#849BF1" />
          <stop offset="1" stopColor="#798DF0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2634_2987"
          x1="126.708"
          y1="16.4333"
          x2="126.708"
          y2="128.447"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5656DB" />
          <stop offset="1" stopColor="#4949BB" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2634_2987"
          x1="215.877"
          y1="280.276"
          x2="21.8367"
          y2="265.178"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CDD7F2" />
          <stop offset="0.35" stopColor="#AABFFB" />
          <stop offset="0.72" stopColor="#849BF1" />
          <stop offset="1" stopColor="#798DF0" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2634_2987"
          x1="300.574"
          y1="98.5488"
          x2="184.563"
          y2="258.479"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.19" stopColor="#92ADF4" />
          <stop offset="0.46" stopColor="#88A1F2" />
          <stop offset="0.78" stopColor="#798DF0" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_2634_2987"
          x1="1.49528"
          y1="341.293"
          x2="51.6834"
          y2="150.448"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.19" stopColor="#92ADF4" />
          <stop offset="0.46" stopColor="#88A1F2" />
          <stop offset="0.78" stopColor="#798DF0" />
        </linearGradient>
        <clipPath id="clip0_2634_2987">
          <rect width="290" height="389.687" fill="white" transform="translate(0 0.125)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const FelixButtonSVG = () => {
  return (
    <svg
      width="44"
      height="50"
      viewBox="0 0 44 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: 'scale(1) translate(2px, -3px)' }}
    >
      <path
        d="M35.3605 11.1668C35.6088 16.244 29.776 18.0448 22.4899 18.3985C15.2037 18.7522 9.22196 17.5237 8.97367 12.4484C8.72539 7.3731 14.3041 0.367674 21.5903 0.0139802C28.8765 -0.339714 35.1122 6.08953 35.3605 11.1649V11.1668Z"
        fill="url(#paint0_linear_2639_4522)"
      />
      <path
        d="M32.2894 10.2255C32.6561 14.1199 28.2329 15.7039 22.6427 16.225C17.0525 16.746 12.4115 16.0063 12.0448 12.1118C11.6781 8.2174 15.727 2.64197 21.3172 2.12093C26.9074 1.5999 31.9228 6.33104 32.2894 10.2255Z"
        fill="url(#paint1_linear_2639_4522)"
      />
      <path
        d="M17.3828 10.0657C17.848 10.0657 18.2251 9.69029 18.2251 9.22715C18.2251 8.764 17.848 8.38855 17.3828 8.38855C16.9177 8.38855 16.5406 8.764 16.5406 9.22715C16.5406 9.69029 16.9177 10.0657 17.3828 10.0657Z"
        fill="white"
      />
      <path
        d="M26.4567 9.22715C26.9219 9.22715 27.299 8.8517 27.299 8.38855C27.299 7.92541 26.9219 7.54996 26.4567 7.54996C25.9915 7.54996 25.6144 7.92541 25.6144 8.38855C25.6144 8.8517 25.9915 9.22715 26.4567 9.22715Z"
        fill="white"
      />
      <path
        d="M19.3997 10.6857C19.6365 10.8948 22.0849 13.0018 24.0922 11.5775C24.3997 11.3588 24.7912 10.9918 25.1579 10.3491"
        stroke="white"
        strokeMiterlimit="10"
      />
      <mask
        id="mask0_2639_4522"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="6"
        width="41"
        height="42"
      >
        <circle cx="20.5" cy="26.5007" r="20.5" fill="url(#paint2_linear_2639_4522)" />
      </mask>
      <g mask="url(#mask0_2639_4522)">
        <path
          d="M9.136 29.6977C9.7739 21.4962 15.5016 19.4767 22.3332 20.0034C29.1649 20.5302 34.5125 23.4034 33.8746 31.605C33.2367 39.8065 26.8558 50.2271 20.0242 49.7004C13.1926 49.1737 8.4981 37.8973 9.136 29.6977Z"
          fill="url(#paint3_linear_2639_4522)"
        />
      </g>
      <path
        d="M36.5618 26.0657C32.7439 29.8232 30.3604 29.6901 28.8249 28.1422C27.2893 26.5962 27.1843 24.2211 31.0041 20.4636C34.8219 16.7061 41.1187 12.9904 42.6524 14.5383C44.1879 16.0842 40.3796 22.3081 36.5618 26.0657Z"
        fill="url(#paint4_linear_2639_4522)"
      />
      <path
        d="M8.46566 28.1003C10.6544 23.2209 12.9233 22.4831 14.9172 23.3692C16.9111 24.2553 17.8737 26.4308 15.685 31.3102C13.4963 36.1897 8.98706 41.9286 6.99124 41.0425C4.99542 40.1564 6.27695 32.9817 8.46566 28.1003Z"
        fill="url(#paint5_linear_2639_4522)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2639_4522"
          x1="8.84665"
          y1="9.84688"
          x2="35.2322"
          y2="8.55542"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#92ADF4" />
          <stop offset="0.35" stopColor="#8EA8F3" />
          <stop offset="0.72" stopColor="#849BF1" />
          <stop offset="1" stopColor="#798DF0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2639_4522"
          x1="22.1662"
          y1="2.08139"
          x2="22.1662"
          y2="16.3727"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5656DB" />
          <stop offset="1" stopColor="#4949BB" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2639_4522"
          x1="60"
          y1="6.00067"
          x2="-8"
          y2="72.5007"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.9997" stopColor="#084D6D" />
          <stop offset="0.9998" stopColor="#084D6D" />
          <stop offset="0.9999" stopColor="#5BC4C0" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2639_4522"
          x1="33.5429"
          y1="35.7441"
          x2="8.78605"
          y2="33.8177"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CDD7F2" />
          <stop offset="0.35" stopColor="#AABFFB" />
          <stop offset="0.72" stopColor="#849BF1" />
          <stop offset="1" stopColor="#798DF0" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_2639_4522"
          x1="44.3491"
          y1="12.5582"
          x2="29.5476"
          y2="32.963"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.19" stopColor="#92ADF4" />
          <stop offset="0.46" stopColor="#88A1F2" />
          <stop offset="0.78" stopColor="#798DF0" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_2639_4522"
          x1="6.19079"
          y1="43.529"
          x2="12.5941"
          y2="19.1798"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.19" stopColor="#92ADF4" />
          <stop offset="0.46" stopColor="#88A1F2" />
          <stop offset="0.78" stopColor="#798DF0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const FelixMessageSVG = () => {
  return (
    <svg width="56" height="80" viewBox="0 0 56 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_29807_49326)">
        <path
          d="M44.4377 18.9C44.8134 26.5845 35.9855 29.31 24.9578 29.8453C13.93 30.3806 4.87662 28.5214 4.50084 20.8398C4.12506 13.1583 12.5686 2.55547 23.5963 2.02014C34.624 1.48482 44.0619 11.2156 44.4377 18.8971V18.9Z"
          fill="url(#paint0_linear_29807_49326)"
        />
        <path
          d="M39.7892 17.4754C40.3442 23.3697 33.6496 25.7671 25.1887 26.5557C16.7279 27.3443 9.70365 26.2247 9.14865 20.3304C8.59366 14.4361 14.7218 5.99764 23.1826 5.20905C31.6435 4.42046 39.2342 11.5811 39.7892 17.4754Z"
          fill="url(#paint1_linear_29807_49326)"
        />
        <path
          d="M17.2279 17.2336C17.9319 17.2336 18.5027 16.6654 18.5027 15.9644C18.5027 15.2634 17.9319 14.6952 17.2279 14.6952C16.5239 14.6952 15.9531 15.2634 15.9531 15.9644C15.9531 16.6654 16.5239 17.2336 17.2279 17.2336Z"
          fill="white"
        />
        <path
          d="M30.9613 15.9644C31.6653 15.9644 32.2361 15.3961 32.2361 14.6952C32.2361 13.9942 31.6653 13.4259 30.9613 13.4259C30.2573 13.4259 29.6865 13.9942 29.6865 14.6952C29.6865 15.3961 30.2573 15.9644 30.9613 15.9644Z"
          fill="white"
        />
        <path
          d="M20.2808 18.1719C20.6392 18.4885 24.345 21.6774 27.383 19.5217C27.8484 19.1907 28.441 18.6352 28.996 17.6624"
          stroke="white"
          strokeMiterlimit="10"
        />
        <path
          d="M4.74638 46.9468C5.71184 34.5337 14.3808 31.4772 24.7206 32.2744C35.0603 33.0716 43.1541 37.4204 42.1886 49.8335C41.2231 62.2466 31.5656 78.0184 21.2258 77.2212C10.8861 76.424 3.78091 59.357 4.74638 46.9468Z"
          fill="url(#paint2_linear_29807_49326)"
        />
        <path
          d="M46.2556 41.4497C40.4772 47.1368 36.8697 46.9353 34.5457 44.5926C32.2216 42.2527 32.0626 38.658 37.8439 32.9709C43.6222 27.2838 53.1526 21.6601 55.4737 24.0028C57.7978 26.3427 52.0339 35.7626 46.2556 41.4497Z"
          fill="url(#paint3_linear_29807_49326)"
        />
        <path
          d="M3.73177 44.5292C7.04442 37.1441 10.4785 36.0274 13.4963 37.3686C16.5141 38.7098 17.971 42.0023 14.6583 49.3874C11.3457 56.7725 4.52091 65.4586 1.50021 64.1174C-1.52049 62.7762 0.419121 51.9172 3.73177 44.5292Z"
          fill="url(#paint4_linear_29807_49326)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_29807_49326"
          x1="4.30859"
          y1="16.9024"
          x2="44.2434"
          y2="14.9477"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#92ADF4" />
          <stop offset="0.35" stopColor="#8EA8F3" />
          <stop offset="0.72" stopColor="#849BF1" />
          <stop offset="1" stopColor="#798DF0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_29807_49326"
          x1="24.4676"
          y1="5.1492"
          x2="24.4676"
          y2="26.7794"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5656DB" />
          <stop offset="1" stopColor="#4949BB" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_29807_49326"
          x1="41.6866"
          y1="56.0981"
          x2="4.21672"
          y2="53.1826"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CDD7F2" />
          <stop offset="0.35" stopColor="#AABFFB" />
          <stop offset="0.72" stopColor="#849BF1" />
          <stop offset="1" stopColor="#798DF0" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_29807_49326"
          x1="58.0418"
          y1="21.006"
          x2="35.6395"
          y2="51.889"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.19" stopColor="#92ADF4" />
          <stop offset="0.46" stopColor="#88A1F2" />
          <stop offset="0.78" stopColor="#798DF0" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_29807_49326"
          x1="0.28873"
          y1="67.8808"
          x2="9.98023"
          y2="31.0278"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.19" stopColor="#92ADF4" />
          <stop offset="0.46" stopColor="#88A1F2" />
          <stop offset="0.78" stopColor="#798DF0" />
        </linearGradient>
        <clipPath id="clip0_29807_49326">
          <rect width="56" height="75.25" fill="white" transform="translate(0 2)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const FelixConfused = () => {
  return (
    <svg
      id="Layer_2"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 157.85 261.46"
    >
      <defs>
        <style>
          {
            '.cls-1{fill:url(#New_Gradient_Swatch_copy);}.cls-2{fill:url(#New_Gradient_Swatch);}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:#fff;}.cls-5{fill:url(#linear-gradient-3);}.cls-6{fill:url(#linear-gradient-2);}'
          }
        </style>
        <linearGradient
          id="New_Gradient_Swatch"
          x1={24.04}
          y1={15.7}
          x2={162.36}
          y2={15.7}
          gradientTransform="translate(-20.14 37.27) rotate(-2.79)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#92adf4" />
          <stop offset={0.35} stopColor="#8ea8f3" />
          <stop offset={0.72} stopColor="#849bf1" />
          <stop offset={1} stopColor="#798df0" />
        </linearGradient>
        <linearGradient
          id="New_Gradient_Swatch_copy"
          x1={74.39}
          y1={10.94}
          x2={74.39}
          y2={86.1}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#5656db" />
          <stop offset={0.46} stopColor="#5151cf" />
          <stop offset={1} stopColor="#4949bb" />
        </linearGradient>
        <linearGradient
          id="linear-gradient"
          x1={922.54}
          y1={938.23}
          x2={1060.86}
          y2={938.23}
          gradientTransform="translate(880.62 1769.09) rotate(-175.57) scale(.94 1.62)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.02} stopColor="#cdd7f2" />
          <stop offset={0.42} stopColor="#aabffb" />
          <stop offset={0.76} stopColor="#92adf4" />
          <stop offset={0.84} stopColor="#8ea8f3" />
          <stop offset={0.93} stopColor="#849bf1" />
          <stop offset={1} stopColor="#798df0" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-2"
          x1={-1748.61}
          y1={932.15}
          x2={-1742.67}
          y2={1059.6}
          gradientTransform="translate(7.84 -1050.16) rotate(-32.2) scale(.3 1.05)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.19} stopColor="#92adf4" />
          <stop offset={0.46} stopColor="#88a1f2" />
          <stop offset={0.78} stopColor="#798df0" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-3"
          x1={1132.98}
          y1={962.86}
          x2={1138.93}
          y2={1090.31}
          gradientTransform="translate(246.98 1277.75) rotate(-174.07) scale(.3 1.05)"
          xlinkHref="#linear-gradient-2"
        />
      </defs>
      <g id="Layer_1-2">
        <path
          className="cls-2"
          d="m143.46,58.72c1.3,26.7-29.24,36.17-67.39,38.03-38.15,1.86-69.47-4.6-70.77-31.29S33.21,1.93,71.36.07c38.15-1.86,70.8,31.95,72.1,58.64Z"
        />
        <path
          className="cls-1"
          d="m127.39,53.77c1.92,20.48-21.24,28.81-50.51,31.55-29.27,2.74-53.57-1.15-55.49-21.63-1.92-20.48,19.28-49.8,48.55-52.54,29.27-2.74,55.53,22.14,57.45,42.62Z"
        />
        <ellipse className="cls-4" cx={51.4} cy={48.52} rx={6.48} ry={4.41} />
        <ellipse
          className="cls-4"
          cx={95.95}
          cy={44.02}
          rx={6.08}
          ry={4.41}
          transform="translate(-7.54 23.17) rotate(-13.25)"
        />
        <path
          className="cls-3"
          d="m6.15,156.17c3.34-43.13,33.33-53.75,69.1-50.98,35.77,2.77,63.77,17.88,60.43,61.01-3.34,43.13-36.75,97.93-72.52,95.16S2.81,199.3,6.15,156.17Z"
        />
        <path
          className="cls-6"
          d="m147.63,113.38c14.98,23.78,11.6,35.82,1.93,41.91-9.68,6.09-21.99,3.93-36.97-19.85-14.98-23.78-26.95-60.19-17.27-66.28,9.68-6.09,37.33,20.43,52.31,44.22Z"
        />
        <path
          className="cls-5"
          d="m.78,154.91c2.9-27.96,12.99-35.34,24.36-34.16,11.37,1.18,19.73,10.48,16.82,38.44s-15.97,63.98-27.34,62.8c-11.37-1.18-16.75-39.12-13.85-67.08Z"
        />
      </g>
    </svg>
  );
};

export const FelixStarsSVG = () => {
  return (
    <svg
      width="227"
      height="216"
      viewBox="0 0 227 216"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_4940_3890)">
        <path
          d="M47.3004 85.449C33.168 87.8309 31.1455 89.7618 28.6502 103.251C26.1549 89.7618 24.1325 87.8309 10 85.449C24.1325 83.0677 26.1549 81.1368 28.6502 67.6465C31.1455 81.1368 33.168 83.0677 47.3004 85.449Z"
          fill="#2D388D"
        />
      </g>
      <g filter="url(#filter1_d_4940_3890)">
        <path
          d="M221.934 108.338C215.832 109.358 214.958 110.186 213.881 115.967C212.803 110.186 211.93 109.358 205.827 108.338C211.93 107.317 212.803 106.49 213.881 100.708C214.958 106.49 215.832 107.317 221.934 108.338Z"
          fill="#2D388D"
        />
      </g>
      <g clipPath="url(#clip0_4940_3890)">
        <path
          d="M167.325 81.9013C168.182 99.5615 148.045 105.825 122.89 107.056C97.7354 108.286 77.0842 104.013 76.227 86.3593C75.3698 68.7057 94.6298 44.3385 119.784 43.1082C144.939 41.8779 166.467 64.241 167.325 81.8946V81.9013Z"
          fill="url(#paint0_linear_4940_3890)"
        />
        <path
          d="M156.729 78.6267C157.995 92.1728 142.724 97.6826 123.424 99.4949C104.125 101.307 88.1021 98.7342 86.8362 85.1881C85.5702 71.6419 99.5487 52.2487 118.848 50.4364C138.148 48.624 155.463 65.0805 156.729 78.6267Z"
          fill="url(#paint1_linear_4940_3890)"
        />
        <path
          d="M105.265 78.0711C106.871 78.0711 108.173 76.7652 108.173 75.1542C108.173 73.5433 106.871 72.2373 105.265 72.2373C103.659 72.2373 102.358 73.5433 102.358 75.1542C102.358 76.7652 103.659 78.0711 105.265 78.0711Z"
          fill="white"
        />
        <path
          d="M136.585 75.1542C138.191 75.1542 139.493 73.8482 139.493 72.2372C139.493 70.6263 138.191 69.3203 136.585 69.3203C134.979 69.3203 133.677 70.6263 133.677 72.2372C133.677 73.8482 134.979 75.1542 136.585 75.1542Z"
          fill="white"
        />
        <path
          d="M76.7875 146.358C78.9898 117.83 98.7641 110.806 122.349 112.638C145.935 114.47 164.397 124.464 162.195 152.992C159.992 181.52 137.963 217.766 114.378 215.934C90.7924 214.102 74.5853 174.885 76.7875 146.358Z"
          fill="url(#paint2_linear_4940_3890)"
        />
        <path
          d="M177.255 119.715C186.176 136.013 183.479 143.824 176.866 147.462C170.259 151.1 162.241 149.189 153.32 132.891C144.399 116.593 137.963 92.087 144.57 88.4425C151.177 84.798 168.333 103.411 177.255 119.708V119.715Z"
          fill="url(#paint3_linear_4940_3890)"
        />
        <path
          d="M73.2467 145.524C75.1588 127.031 81.8118 122.149 89.3087 122.93C96.8057 123.71 102.318 129.862 100.399 148.355C98.4805 166.849 89.8692 190.674 82.3722 189.893C74.8753 189.113 71.3279 164.018 73.2401 145.524H73.2467Z"
          fill="url(#paint4_linear_4940_3890)"
        />
        <path
          d="M123.674 89.0146C125.879 88.8052 127.543 87.3353 127.391 85.7316C127.24 84.1278 125.33 82.9974 123.126 83.2068C120.922 83.4162 119.258 84.8861 119.409 86.4899C119.561 88.0937 121.47 89.224 123.674 89.0146Z"
          fill="white"
        />
      </g>
      <g filter="url(#filter2_d_4940_3890)">
        <path
          d="M196.502 23.9877C184.069 24.8458 183.373 25.5418 182.515 37.9753C181.656 25.5418 180.96 24.8458 168.527 23.9877C180.96 23.1295 181.656 22.4335 182.515 10C183.373 22.4335 184.069 23.1295 196.502 23.9877Z"
          fill="url(#paint5_linear_4940_3890)"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_4940_3890"
          x="0"
          y="57.6465"
          width="57.3004"
          height="55.6045"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.47451 0 0 0 0 0.552941 0 0 0 0 0.941176 0 0 0 0.32 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4940_3890" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4940_3890"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_4940_3890"
          x="200.827"
          y="95.708"
          width="26.1071"
          height="25.2588"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.47451 0 0 0 0 0.552941 0 0 0 0 0.941176 0 0 0 0.54 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4940_3890" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4940_3890"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_4940_3890"
          x="158.527"
          y="0"
          width="47.9753"
          height="47.9756"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.572549 0 0 0 0 0.678431 0 0 0 0 0.956863 0 0 0 0.3 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4940_3890" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4940_3890"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_4940_3890"
          x1="75.7881"
          y1="77.309"
          x2="166.884"
          y2="72.8835"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#92ADF4" />
          <stop offset="0.35" stopColor="#8EA8F3" />
          <stop offset="0.72" stopColor="#849BF1" />
          <stop offset="1" stopColor="#798DF0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_4940_3890"
          x1="121.782"
          y1="50.2975"
          x2="121.782"
          y2="100.011"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5656DB" />
          <stop offset="0.46" stopColor="#5151CF" />
          <stop offset="1" stopColor="#4949BB" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_4940_3890"
          x1="160.313"
          y1="166.546"
          x2="74.8346"
          y2="159.944"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.02" stopColor="#CDD7F2" />
          <stop offset="0.42" stopColor="#AABFFB" />
          <stop offset="0.76" stopColor="#92ADF4" />
          <stop offset="0.84" stopColor="#8EA8F3" />
          <stop offset="0.93" stopColor="#849BF1" />
          <stop offset="1" stopColor="#798DF0" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_4940_3890"
          x1="138.431"
          y1="80.7395"
          x2="192.431"
          y2="149.516"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.19" stopColor="#92ADF4" />
          <stop offset="0.46" stopColor="#88A1F2" />
          <stop offset="0.78" stopColor="#798DF0" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_4940_3890"
          x1="80.8497"
          y1="199.732"
          x2="75.718"
          y2="112.337"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.19" stopColor="#92ADF4" />
          <stop offset="0.46" stopColor="#88A1F2" />
          <stop offset="0.78" stopColor="#798DF0" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_4940_3890"
          x1="174.461"
          y1="17.6296"
          x2="192.687"
          y2="35.856"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.2756" stopColor="#2D378D" />
          <stop offset="1" stopColor="#4E64D0" />
        </linearGradient>
        <clipPath id="clip0_4940_3890">
          <rect
            width="110.206"
            height="172.938"
            fill="white"
            transform="translate(72.7324 43.0615)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const RobotIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path d="M 3.16666 16.625 V 12.6667 C 3.16666 12.2312 3.32169 11.8585 3.63176 11.5484 C 3.94183 11.2384 4.31457 11.0833 4.74999 11.0833 H 14.25 C 14.6854 11.0833 15.0582 11.2384 15.3682 11.5484 C 15.6783 11.8585 15.8333 12.2312 15.8333 12.6667 V 16.625 H 3.16666 Z M 7.12499 10.2917 C 6.02985 10.2917 5.09634 9.90573 4.32447 9.13385 C 3.55259 8.36198 3.16666 7.42847 3.16666 6.33333 C 3.16666 5.23819 3.55259 4.30469 4.32447 3.53281 C 5.09634 2.76094 6.02985 2.375 7.12499 2.375 H 11.875 C 12.9701 2.375 13.9036 2.76094 14.6755 3.53281 C 15.4474 4.30469 15.8333 5.23819 15.8333 6.33333 C 15.8333 7.42847 15.4474 8.36198 14.6755 9.13385 C 13.9036 9.90573 12.9701 10.2917 11.875 10.2917 H 7.12499 Z M 4.74999 15.0417 H 14.25 V 12.6667 H 4.74999 V 15.0417 Z M 7.12499 8.70833 H 11.875 C 12.5347 8.70833 13.0955 8.47743 13.5573 8.01562 C 14.0191 7.55382 14.25 6.99306 14.25 6.33333 C 14.25 5.67361 14.0191 5.11285 13.5573 4.65104 C 13.0955 4.18924 12.5347 3.95833 11.875 3.95833 H 7.12499 C 6.46527 3.95833 5.9045 4.18924 5.4427 4.65104 C 4.98089 5.11285 4.74999 5.67361 4.74999 6.33333 C 4.74999 6.99306 4.98089 7.55382 5.4427 8.01562 C 5.9045 8.47743 6.46527 8.70833 7.12499 8.70833 Z M 7.12499 7.125 C 7.3493 7.125 7.53732 7.04913 7.68905 6.8974 C 7.84079 6.74566 7.91666 6.55764 7.91666 6.33333 C 7.91666 6.10903 7.84079 5.92101 7.68905 5.76927 C 7.53732 5.61753 7.3493 5.54167 7.12499 5.54167 C 6.90068 5.54167 6.71266 5.61753 6.56093 5.76927 C 6.40919 5.92101 6.33332 6.10903 6.33332 6.33333 C 6.33332 6.55764 6.40919 6.74566 6.56093 6.8974 C 6.71266 7.04913 6.90068 7.125 7.12499 7.125 Z M 11.875 7.125 C 12.0993 7.125 12.2873 7.04913 12.4391 6.8974 C 12.5908 6.74566 12.6667 6.55764 12.6667 6.33333 C 12.6667 6.10903 12.5908 5.92101 12.4391 5.76927 C 12.2873 5.61753 12.0993 5.54167 11.875 5.54167 C 11.6507 5.54167 11.4627 5.61753 11.3109 5.76927 C 11.1592 5.92101 11.0833 6.10903 11.0833 6.33333 C 11.0833 6.55764 11.1592 6.74566 11.3109 6.8974 C 11.4627 7.04913 11.6507 7.125 11.875 7.125 Z" />
    </SvgIcon>
  );
};

export const FelixGPTIcon = () => {
  return (
    <svg width="50" height="49" viewBox="0 0 50 49" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_18404_9220)">
        <circle cx="25" cy="20" r="20" fill="url(#paint0_linear_18404_9220)" />
      </g>
      <mask
        id="mask0_18404_9220"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="5"
        y="0"
        width="40"
        height="40"
      >
        <circle cx="25" cy="20" r="20" fill="url(#paint1_linear_18404_9220)" />
      </mask>
      <g mask="url(#mask0_18404_9220)">
        <path
          d="M40.7577 17.6294C41.04 23.6242 34.4086 25.7505 26.1248 26.1681C17.841 26.5857 11.0402 25.1353 10.758 19.1427C10.4757 13.15 16.8183 4.87846 25.1021 4.46084C33.3859 4.04322 40.4754 11.6345 40.7577 17.6271V17.6294Z"
          fill="url(#paint2_linear_18404_9220)"
        />
        <path
          d="M37.2661 16.5179C37.683 21.1162 32.6541 22.9865 26.2984 23.6017C19.9428 24.2169 14.6664 23.3435 14.2495 18.7452C13.8326 14.1469 18.4359 7.56375 24.7915 6.94855C31.1471 6.33334 36.8492 11.9196 37.2661 16.5179Z"
          fill="url(#paint3_linear_18404_9220)"
        />
        <path
          d="M20.3184 16.3295C20.8473 16.3295 21.276 15.8861 21.276 15.3393C21.276 14.7924 20.8473 14.3491 20.3184 14.3491C19.7896 14.3491 19.3608 14.7924 19.3608 15.3393C19.3608 15.8861 19.7896 16.3295 20.3184 16.3295Z"
          fill="white"
        />
        <path
          d="M30.6346 15.3392C31.1634 15.3392 31.5922 14.8959 31.5922 14.3491C31.5922 13.8022 31.1634 13.3589 30.6346 13.3589C30.1057 13.3589 29.677 13.8022 29.677 14.3491C29.677 14.8959 30.1057 15.3392 30.6346 15.3392Z"
          fill="white"
        />
        <path
          d="M22.6113 17.0615C22.8806 17.3085 25.6643 19.7962 27.9464 18.1145C28.296 17.8563 28.7411 17.423 29.158 16.6641"
          stroke="white"
          strokeWidth="0.625"
          strokeMiterlimit="10"
        />
        <mask
          id="mask1_18404_9220"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="11"
          width="48"
          height="49"
        >
          <ellipse
            cx="23.8624"
            cy="35.7349"
            rx="23.3069"
            ry="24.2051"
            fill="url(#paint4_linear_18404_9220)"
          />
        </mask>
        <g mask="url(#mask1_18404_9220)">
          <path
            d="M10.9425 39.5098C11.6677 29.8259 18.1797 27.4415 25.9467 28.0634C33.7137 28.6853 39.7935 32.0779 39.0683 41.7618C38.343 51.4456 31.0885 63.7497 23.3215 63.1278C15.5545 62.5058 10.2172 49.1914 10.9425 39.5098Z"
            fill="url(#paint5_linear_18404_9220)"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_18404_9220"
          x="0.555555"
          y="0"
          width="48.8889"
          height="48.8889"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4.44444" />
          <feGaussianBlur stdDeviation="2.22222" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.141832 0 0 0 0 0.141832 0 0 0 0 0.141832 0 0 0 0.09 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_18404_9220" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_18404_9220"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_18404_9220"
          x1="63.5366"
          y1="5.27613e-07"
          x2="-2.80488"
          y2="64.878"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E548FF" />
          <stop offset="0.9997" stopColor="#084D6D" />
          <stop offset="0.9998" stopColor="#084D6D" />
          <stop offset="0.9999" stopColor="#5BC4C0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_18404_9220"
          x1="63.5366"
          y1="5.27613e-07"
          x2="-2.80488"
          y2="64.878"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E548FF" />
          <stop offset="0.9997" stopColor="#084D6D" />
          <stop offset="0.9998" stopColor="#084D6D" />
          <stop offset="0.9999" stopColor="#5BC4C0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_18404_9220"
          x1="10.6136"
          y1="16.0709"
          x2="40.617"
          y2="14.6569"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#92ADF4" />
          <stop offset="0.35" stopColor="#8EA8F3" />
          <stop offset="0.72" stopColor="#849BF1" />
          <stop offset="1" stopColor="#798DF0" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_18404_9220"
          x1="25.7567"
          y1="6.90186"
          x2="25.7567"
          y2="23.7762"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5656DB" />
          <stop offset="1" stopColor="#4949BB" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_18404_9220"
          x1="68.7708"
          y1="11.5298"
          x2="-11.3945"
          y2="87.0173"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.9997" stopColor="#084D6D" />
          <stop offset="0.9998" stopColor="#084D6D" />
          <stop offset="0.9999" stopColor="#5BC4C0" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_18404_9220"
          x1="38.6912"
          y1="46.649"
          x2="10.5322"
          y2="44.5393"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CDD7F2" />
          <stop offset="0.35" stopColor="#AABFFB" />
          <stop offset="0.72" stopColor="#849BF1" />
          <stop offset="1" stopColor="#798DF0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const TextCompareIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 70 70" fill="none">
      <g filter="url(#filter0_d_29898_56262)">
        <circle cx="35" cy="31" r="16" fill="#7A8EF1" />
      </g>
      <mask
        id="mask0_29898_56262"
        style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="25"
        y="21"
        width="20"
        height="20"
      >
        <rect x="25" y="21" width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_29898_56262)">
        <path
          d="M30.8333 35.1667H36.6667V33.5H30.8333V35.1667ZM30.8333 31.8333H39.1667V30.1667H30.8333V31.8333ZM30.8333 28.5H39.1667V26.8333H30.8333V28.5ZM29.1667 38.5C28.7083 38.5 28.316 38.3368 27.9896 38.0104C27.6632 37.684 27.5 37.2917 27.5 36.8333V25.1667C27.5 24.7083 27.6632 24.316 27.9896 23.9896C28.316 23.6632 28.7083 23.5 29.1667 23.5H40.8333C41.2917 23.5 41.684 23.6632 42.0104 23.9896C42.3368 24.316 42.5 24.7083 42.5 25.1667V36.8333C42.5 37.2917 42.3368 37.684 42.0104 38.0104C41.684 38.3368 41.2917 38.5 40.8333 38.5H29.1667ZM29.1667 36.8333H40.8333V25.1667H29.1667V36.8333Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_29898_56262"
          x="0.333333"
          y="0.333333"
          width="69.3333"
          height="69.3333"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="2.66667"
            operator="dilate"
            in="SourceAlpha"
            result="effect1_dropShadow_29898_56262"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.650533 0 0 0 0 0.650533 0 0 0 0 0.650533 0 0 0 0.25 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_29898_56262" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_29898_56262"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
